export var ArcGisItmHeadingEnum;
(function (ArcGisItmHeadingEnum) {
    ArcGisItmHeadingEnum["name"] = "Name";
    ArcGisItmHeadingEnum["category"] = "Category";
})(ArcGisItmHeadingEnum || (ArcGisItmHeadingEnum = {}));
export const ArcGisItmHeadingEnumLookup = new Map([
    [ArcGisItmHeadingEnum.name, "name"],
    [ArcGisItmHeadingEnum.category, "category"]
]);
export class ArcgisItemsConstants {
    static Headings = {
        PageHeadings: "ArcGis items"
    };
    static StepName = "Arcgis item tab";
}
